import React, { Component } from 'react'
import {
    InputGroup, InputGroupAddon, Button, Input, Spinner
} from 'reactstrap'
/* import { database } from '../../config' */
import { Icon } from 'react-icons-kit'
import { ic_search } from 'react-icons-kit/md/ic_search'

import './buscar.css'

export default class BuscarProductos extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: ''
        }
        this.onChangeSearch = this.onChangeSearch.bind(this)
        this.onSearch = this.onSearch.bind(this)
    }

    onChangeSearch(e) {
        e.preventDefault()
        this.props.onChangeSearch(e.target.value)
    }

    onSearch() {
        //const tesNode = ReactDOM.findDOMNode(this.refs.productos)
        //window.scrollTo(0, tesNode.offsetTop)

        //console.log('buscar')
    }

    render() {

        return (
            <InputGroup className="btnBuscarProds" >
                <Input onChange={this.onChangeSearch} placeholder="Buscar..." />
                <InputGroupAddon addonType="append">
                    <Button color="dark" onClick={this.props.buscarProducto}>
                        {
                            this.props.buscando ?
                                <Spinner style={{ width: '20px', height: '20px' }} />
                                :
                                <Icon size={20} icon={ic_search} />
                        }
                    </Button>
                </InputGroupAddon>
            </InputGroup>
        )
    }

}